import { stringToTime } from '../../utils/datepickerUtil';
import { VALIDATION_TEMPLATE } from './validationTemplete';

export const BUSINESS_REPORT_VALIDATION = {
  FIELDS: [
    'date',
    'projectId',
    'manHoursA',
    'startTime',
    'endTime',
    'manHoursTotal',
  ],
  MESSAGE: {
    date: {
      required: VALIDATION_TEMPLATE.required('日付'),
    },
    projectId: {
      required: VALIDATION_TEMPLATE.required('プロジェクト'),
    },
    manHoursA: {
      validateManHoursCategory: VALIDATION_TEMPLATE.manhoursCheck(),
    },
    startTime: {
      required: VALIDATION_TEMPLATE.required('始業時間'),
    },
    endTime: {
      required: VALIDATION_TEMPLATE.required('終業時間'),
      validateStartBeforeEnd: VALIDATION_TEMPLATE.startBeforeEnd(),
    },
  },
  RULES: {
    date: {
      required: true,
    },
    projectId: {
      required: true,
    },
    manHoursA: {
      validateManHoursCategory: (v: string, all: any) =>
        validateManHoursCategory(v, all),
    },
    startTime: {
      required: true,
    },
    endTime: {
      required: true,
      validateStartBeforeEnd: (v: string, all: any) => {
        if (!v || !all?.startTime) return false;
        const startTime = stringToTime(all.startTime);
        const endTime = stringToTime(v);

        if (!startTime || !endTime) return false;

        return startTime < endTime;
      },
    },
  },
};

// 工数Aの判定時に工数A～Eのうち1つだけが選択されているかを確認する
const validateManHoursCategory = (v: string, all: any) => {
  const field = [
    all.manHoursA,
    all.manHoursB,
    all.manHoursC,
    all.manHoursD,
    all.manHoursE,
  ];

  const checkRequired = field.some((value) => value && value !== '');
  const checkOnlyOne =
    field.filter((value) => value && value !== '').length === 1;

  return checkRequired && checkOnlyOne;
};
